module.exports = __webpack_public_path__ + "img/full1-min.21617f25.png";